import * as tslib_1 from "tslib";
import showLinkContextMenu from './LinkContextMenu';
import ReactComment from './ReactComment';
import { addComposeLinkViewState } from '../actions/internalActions';
import { getDisplayDateFromEwsDate } from 'owa-datetime/lib/displaydate/getDisplayDateFromEwsDate';
import { now } from 'owa-datetime/lib/displaydate/now';
import formatShortMonthDayYearFormat from 'owa-datetime/lib/formatters/formatShortMonthDayYearFormat';
import { getIconForFile } from 'owa-file-icon';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { isGuestUrlPermissionLevel } from 'owa-sharing-data';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { COMPOSE_ONLY_ATTACHMENT_CONTENT_END, COMPOSE_ONLY_ATTACHMENT_CONTENT_START, } from 'owa-attachment-link-common';
var linkStyles = require('./Link.scss');
var classNames = require('classnames/bind').bind(linkStyles);
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getAnchorStyle = function (isValidResponse) {
            if (isValidResponse) {
                // Highlighted Background
                return {
                    padding: '0px 2px',
                    backgroundColor: 'rgb(244,244,244)',
                    borderRadius: '2px',
                };
            }
            return {};
        };
        _this.getFileIconStyle = function () {
            return {
                width: '16px',
                height: '16px',
                verticalAlign: 'middle',
                paddingRight: '2px',
            };
        };
        _this.getErrorIconStyle = function () {
            return {
                width: '12px',
                height: '12px',
                verticalAlign: 'top',
            };
        };
        _this.getAnchorTextColor = function (isLinkWithSharingIssue) {
            if (isLinkWithSharingIssue) {
                return linkStyles.linkWithSharingIssue;
            }
        };
        _this.getErrorIcon = function () {
            return format('{0}{1}', getPackageBaseUrl(), 'resources/images/redinfo_24.png');
        };
        return _this;
    }
    Link.prototype.render = function () {
        var _this = this;
        return (React.createElement("a", { ref: function (ref) { return (_this.link = ref); }, href: this.props.url, style: tslib_1.__assign({}, this.props.originalAnchor.style, this.getAnchorStyle(this.props.isValidResponse)), id: this.props.originalAnchor.id, className: classNames(this.props.originalAnchor.className, this.getAnchorTextColor(this.props.isLinkWithSharingIssue)) },
            React.createElement("img", { src: this.props.fileIcon, style: this.getFileIconStyle() }),
            this.props.fileName,
            React.createElement(ReactComment, { text: COMPOSE_ONLY_ATTACHMENT_CONTENT_START }),
            React.createElement("img", { src: this.getErrorIcon(), hidden: !this.props.shouldDisplayErrorIcon, style: this.getErrorIconStyle() }),
            React.createElement(ReactComment, { text: COMPOSE_ONLY_ATTACHMENT_CONTENT_END })));
    };
    Link.prototype.componentDidMount = function () {
        // We need to replace the child only so we keep any text typed under the parent element before the new anchor
        this.props.editor.replaceNode(this.props.originalAnchor, this.link);
        this.props.editor.triggerContentChangedEvent('Link');
        // Guarantee the cursor is after the added link
        if (this.props.editor.getSelectionRange().startContainer === this.link.parentNode &&
            this.props.editor.getSelectionRange().endContainer === this.link.parentNode) {
            this.props.editor.getSelectionRange().setStartAfter(this.link);
        }
        addComposeLinkViewState(this.link.id);
        showLinkContextMenu(this.link);
    };
    return Link;
}(React.Component));
export function beautifySharingLink(editor, anchorElement, sharingLinkInfo, isValidResponse, hasValidFileName, mimeType) {
    var fileName = getDisplayName(anchorElement.text, sharingLinkInfo, hasValidFileName);
    // to get the file icon, use the original name that came from the response, as the text filename could have been modified for display
    var fileIcon = getFileIcon(sharingLinkInfo.fileName, hasValidFileName, mimeType);
    var displayErrorIcon = shouldDisplayErrorIcon(hasValidFileName, sharingLinkInfo.sharingInfo.canShareInternally, sharingLinkInfo.permissionLevel);
    var linkWithSharingIssue = isLinkWithSharingIssue(hasValidFileName, isValidResponse, sharingLinkInfo);
    var anchorContainer = document.createElement('span');
    ReactDOM.render(React.createElement(Link, { url: anchorElement.href, fileName: fileName, fileIcon: fileIcon, isValidResponse: isValidResponse, shouldDisplayErrorIcon: displayErrorIcon, isLinkWithSharingIssue: linkWithSharingIssue, editor: editor, originalAnchor: anchorElement }), anchorContainer);
}
function getDisplayName(anchorText, sharingLinkInfo, hasValidFileName) {
    var displayName = anchorText;
    if (hasValidFileName) {
        var fileName = sharingLinkInfo.fileName;
        displayName = fileName;
        if (sharingLinkInfo.sharingInfo.expirationDate) {
            var expirationDate = sharingLinkInfo.sharingInfo.expirationDate;
            if (now().getTime() < new Date(expirationDate).getTime()) {
                var formattedExpirationDate = getDisplayDateFromEwsDate(expirationDate);
                displayName = format(strings.expiringLinkText, fileName, formatShortMonthDayYearFormat(formattedExpirationDate));
            }
            else {
                displayName = format(strings.expiredLinkText, fileName);
            }
        }
    }
    return displayName;
}
function isLinkWithSharingIssue(hasValidFileName, isValidResponse, sharingLinkInfo) {
    return ((hasValidFileName &&
        sharingLinkInfo.sharingInfo.expirationDate &&
        now().getTime() >= new Date(sharingLinkInfo.sharingInfo.expirationDate).getTime()) ||
        shouldDisplayErrorIcon(isValidResponse, sharingLinkInfo.sharingInfo.canShareInternally, sharingLinkInfo.permissionLevel));
}
function getFileIcon(fileName, hasValidFileName, mimeType) {
    if (hasValidFileName) {
        var fileIcon = getIconForFile(fileName, mimeType === 'text/directory', mimeType);
        return fileIcon.cdn || '';
    }
    return '';
}
function shouldDisplayErrorIcon(isValidResponse, canShareInternally, permissionLevel) {
    return isValidResponse && !canShareInternally && !isGuestUrlPermissionLevel(permissionLevel);
}
//# sourceMappingURL=Link.js.map